import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledBoxInside = styled.div`
  display: block;
  padding-left: ${rem('16px')};
  padding-right: ${rem('16px')};
  margin: auto;
  ${mediaqueries.greaterThan('tablet')`
    padding-left: ${rem('25px')};
    padding-right: ${rem('25px')};
    padding-bottom: ${rem('70px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('1232px')};
    margin: 0 auto ${rem('20px')} auto;
    padding-left: 0;
    padding-right: 0;
  `};
`;

export { StyledBoxInside };
